/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiConversionFromJSON, ApiConversionToJSON, } from './ApiConversion';
import { ApiConversionStateFromJSON, ApiConversionStateToJSON, } from './ApiConversionState';
import { ApiDataFromJSON, ApiDataToJSON, } from './ApiData';
import { ApiLeadFromJSON, ApiLeadToJSON, } from './ApiLead';
import { ApiLeadConversionStatusFromJSON, ApiLeadConversionStatusToJSON, } from './ApiLeadConversionStatus';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
import { ApiSaleFromJSON, ApiSaleToJSON, } from './ApiSale';
import { ApiSessionFromJSON, ApiSessionToJSON, } from './ApiSession';
export function ApiLeadConversionFromJSON(json) {
    return ApiLeadConversionFromJSONTyped(json, false);
}
export function ApiLeadConversionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'analyticsSynced': !exists(json, 'analyticsSynced') ? undefined : json['analyticsSynced'],
        'cancelled': !exists(json, 'cancelled') ? undefined : json['cancelled'],
        'conversion': !exists(json, 'conversion') ? undefined : ApiConversionFromJSON(json['conversion']),
        'conversionId': !exists(json, 'conversionId') ? undefined : json['conversionId'],
        'conversionStateId': !exists(json, 'conversionStateId') ? undefined : json['conversionStateId'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'data': !exists(json, 'data') ? undefined : ApiDataFromJSON(json['data']),
        'dataId': !exists(json, 'dataId') ? undefined : json['dataId'],
        'fbc': !exists(json, 'fbc') ? undefined : json['fbc'],
        'fbp': !exists(json, 'fbp') ? undefined : json['fbp'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'lead': !exists(json, 'lead') ? undefined : ApiLeadFromJSON(json['lead']),
        'leadId': !exists(json, 'leadId') ? undefined : json['leadId'],
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'rand': !exists(json, 'rand') ? undefined : json['rand'],
        'sale': !exists(json, 'sale') ? undefined : ApiSaleFromJSON(json['sale']),
        'saleId': !exists(json, 'saleId') ? undefined : json['saleId'],
        'session': !exists(json, 'session') ? undefined : ApiSessionFromJSON(json['session']),
        'sessionId': !exists(json, 'sessionId') ? undefined : json['sessionId'],
        'state': !exists(json, 'state') ? undefined : ApiConversionStateFromJSON(json['state']),
        'status': !exists(json, 'status') ? undefined : ApiLeadConversionStatusFromJSON(json['status']),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}
export function ApiLeadConversionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'analyticsSynced': value.analyticsSynced,
        'cancelled': value.cancelled,
        'conversion': ApiConversionToJSON(value.conversion),
        'conversionId': value.conversionId,
        'conversionStateId': value.conversionStateId,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'data': ApiDataToJSON(value.data),
        'dataId': value.dataId,
        'fbc': value.fbc,
        'fbp': value.fbp,
        'id': value.id,
        'lead': ApiLeadToJSON(value.lead),
        'leadId': value.leadId,
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'rand': value.rand,
        'sale': ApiSaleToJSON(value.sale),
        'saleId': value.saleId,
        'session': ApiSessionToJSON(value.session),
        'sessionId': value.sessionId,
        'state': ApiConversionStateToJSON(value.state),
        'status': ApiLeadConversionStatusToJSON(value.status),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
